import * as Scrivito from "scrivito";
import React from "react";
import { ObjValidator } from "components";

const UserListTemp = Scrivito.connect(() => (
  <div className="w-100 h-100 d-flex justify-content-center align-items-center">
    Comming soon...
  </div>
));

const CheckedPage = (props) => (
  <ObjValidator {...props}>
    {/* <UserList {...props} /> */}
    <UserListTemp />
  </ObjValidator>
);
export default CheckedPage;
Scrivito.provideComponent("UserList", CheckedPage);
